import * as React from 'react';
import { connect } from 'react-redux';
import * as info from '../../appRedux/actions/info';

function WorkingStatus(props) {
  return <></>;
}

const mapStateToProps = (state) => {
  return {
    field: state.field,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    operatorUpdateOnlineAction: () => dispatch(info.operatorUpdateOnlineAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkingStatus);
